/**
 * @generated SignedSource<<418720d4dac6c20a6190b3645e6af96a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LinkedType = "MODULE" | "MODULE_GROUP" | "TASK" | "TEMPLATE" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FlowLink_flow$data = {
  readonly linkedType: LinkedType;
  readonly rowId: UUID;
  readonly " $fragmentType": "FlowLink_flow";
};
export type FlowLink_flow$key = {
  readonly " $data"?: FlowLink_flow$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlowLink_flow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlowLink_flow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedType",
      "storageKey": null
    }
  ],
  "type": "Flow",
  "abstractKey": null
};

(node as any).hash = "fffcc8571266054aa474a54dbf1667d2";

export default node;
